export const blockIconsHouseholdModeFanNew = (
	<span className='material-symbols-outlined'>mode_fan</span>
);
